import React from "react";
import {
  IconButton,
  Box,
  Tooltip,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { accountActions, cartActions } from "../actions";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MoreIcon from "@mui/icons-material/MoreVert";


const style = {
  nameAccount: {
    fontSize: "9px"
  }
}

export function BasicMenu(account, dispatch, navigate, handleLogOut) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    return;
  };

  const backCustomerList = () => {
    setAnchorEl(null);
    dispatch(cartActions.clear());
    dispatch(accountActions.removeCustomerId(account.salesData));
    navigate("/products");
  };


  return (
    <>
      <Tooltip title="Opciones del menú">
        <IconButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <MoreIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}

      >
        <MenuItem onClick={backCustomerList}>Volver a Lista Clientes</MenuItem>
        <MenuItem onClick={handleLogOut}>Salir</MenuItem>
      </Menu>
    </>
  );
}

export default function AccountInfo(props) {
  const { ...rest } = props;

  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("sm"))
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogOut = () => {
    dispatch(cartActions.clear());
    dispatch(accountActions.logOut());
    navigate("/");
  };

  const handleMenu = () => {
    navigate("/menu");
  };

  if (location.pathname === "/login") return null;

  const description =
    account.unique_name.length > 30
      ? `${account.unique_name.substring(0, 15)}...`
      : account.unique_name;

  const loggedInContent = (
    <>
      <Tooltip title="Menu">
        <IconButton color="inherit" onClick={handleMenu} size="large">
          <AccountCircleIcon fontSize={mobile ? "medium" : "large"} />
        </IconButton>
      </Tooltip>
      <Box component="span" style={mobile ? style.nameAccount : { fontSize: "" }}>
        {Object.keys(account.salesData).length !== 0
          ? `${description} (${account.salesData.fullName})`
          : `${account.fullName}`}
      </Box>
      {Object.keys(account.salesData).length !== 0 ? (
        BasicMenu(account, dispatch, navigate, handleLogOut)
      ) : (
        <Tooltip title="Salir">
          <IconButton color="inherit" onClick={handleLogOut} size="large">
            <ExitToAppIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );

  const anonymousContent = (
    <Button
      component={Link}
      variant="outlined"
      style={{ color: "black", borderColor: "black", opacity: ".7" }}
      to={{ pathname: "/login", state: { redir: location.pathname } }}
    >
      Ingresar
    </Button>
  );

  return (
    <div {...rest}>
      {account.isLoggedIn ? loggedInContent : anonymousContent}
    </div>
  );
}
